module.exports = __webpack_public_path__ + "static/media/buat-aspirasi.bd350a37.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Assets/buat-aspirasi.svg
// module id = 73
// module chunks = 1